import { useEffect, useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { excludeNullOrUndefined } from 'checkout/utils'
import * as Analytics from 'analytics/analytics'
import { searchResultCount, SearchResultType } from 'analytics/optimizely/events'

export default function useSearchResultStatsTrack(listKey: string) {
  const listMeta = useAppSelector(state => state.offer.searchResultMetadata.offerMetaData[listKey])

  const listStats = useMemo(() => {
    if (listMeta) {
      const offerMetas = Object.values(listMeta).filter(excludeNullOrUndefined)
      const allCount = offerMetas.length
      const flashCount = offerMetas.filter(meta => meta.type === 'hotel').length
      const lpcCount = offerMetas.filter(meta => meta.type === 'tactical_ao_hotel').length
      const bedbankCount = offerMetas.filter(meta => meta.kind === 'bedbank').length
      return {
        allCount,
        flashCount,
        lpcCount,
        bedbankCount,
      }
    }
  }, [listMeta])

  useEffect(() => {
    if (listStats) {
      Analytics.track('search-result-count', searchResultCount(SearchResultType.All, listStats.allCount))
      Analytics.track('search-result-count', searchResultCount(SearchResultType.Flash, listStats.flashCount))
      Analytics.track('search-result-count', searchResultCount(SearchResultType.LPC, listStats.lpcCount))
      Analytics.track('search-result-count', searchResultCount(SearchResultType.Bedbank, listStats.bedbankCount))
    }
  }, [listStats])
}
